// 並び替え用の純関数ユーティリティ。
// gardenapp の src/lib/sortable-reorder.ts と同じ思想で、SortableContext の
// 「跳ね」対策の核となるローカル state 同期に使う。

export function mergePreservingOrder<T extends { id: string | number }>(
  prev: T[],
  server: T[],
): T[] {
  // server を id で引けるように
  const serverMap = new Map<string | number, T>(server.map((s) => [s.id, s]))
  const result: T[] = []
  // prev の順序を維持しつつ、属性は server 値で上書き
  for (const p of prev) {
    const fromServer = serverMap.get(p.id)
    if (fromServer) {
      result.push(fromServer)
      serverMap.delete(p.id)
    }
    // prev にあって server に無い行 = サーバで削除された → 結果に含めない
  }
  // server だけにある新規行は末尾に追加
  for (const fresh of serverMap.values()) {
    result.push(fresh)
  }
  return result
}
